import { FormDialog } from "../../components/FormDialog/FormDialog";

const UsersDialog = ({ formId, readOnly, saveData, schema, uiSchema, formData, handleFormChange }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            schema={schema}
            uiSchema={uiSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveData}
        />
    );
};

export default UsersDialog;
